import React from "react";
import { WHY_US } from "@/data/content";
import { WHY } from "@/constants/testIds";

export default function WhyUs() {
  return (
    <section id="why" data-testid={WHY.section} className="section bg-[var(--owrs-surface)]/40">
      <div className="container-owrs">
        <div className="max-w-3xl mb-16">
          <div className="overline mb-4">04 — Why OWRS</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter leading-[1.05]">
            A garage that <span className="text-[var(--owrs-accent)]">takes it personally.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_US.map((w) => (
            <div
              key={w.slug}
              data-testid={WHY.card(w.slug)}
              className="card-owrs"
            >
              <h3 className="font-display text-xl font-medium mb-3">{w.title}</h3>
              <p className="text-sm text-[var(--owrs-text-muted)] leading-relaxed">{w.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
